<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((f) => f.isCheckedToDelete)"
						@confirm="deleteModels"
						@cancel="toggleExclusionAlert"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.fzda_cd_codigo }} - {{ $t('name') }} :
								{{ item.fzda_nm_nome }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVFazenda()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:value-selected="valueSelected.menu"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>

		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="quantityPerPage"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			style="padding: 1rem"
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="!actionImportShape"
		>
			<template #actions>
				<div class="flex w-full justify-center py-6">
					<BreadCrumb
						v-model="step"
						:crumbs="[
							{ name: `${isEdit ? $t('edition') : $t('registry')}`, step: 0 },
							{ name: 'GIS', step: 1 },
						]"
					/>
				</div>
			</template>

			<template #form>
				<div
					v-if="!actionImportShape"
					class="form__template__section"
					style="display: flex; gap: 0.5rem; flex-direction: column"
				>
					<Switcher
						v-model="model.ativo"
						style="margin-top: 1rem"
						:label="$t('usefulFarm')"
						:disabled="criandoFazenda"
						@input="atualiza_status_fazenda()"
					/>
					<InputText
						v-model="model.fzda_nm_nome"
						:label="$t('farmName') + '*'"
					/>
					<InputText
						v-model="model.fzda_nm_municipio"
						:label="$t('city') + '*'"
					/>
					<InputText
						v-model="model.fzda_nm_pais"
						:label="$t('country') + '*'"
					/>

					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('description'), $t('owner'), $t('tenant')]"
          > -->
					<div style="display: flex; gap: 0.5rem; flex-direction: column">
						<InputText
							v-model="model.fzda_ds_descricao"
							:label="$t('description')"
						/>
						<InputText
							v-model="model.fzda_nm_proprietario"
							:label="$t('owner')"
						/>
						<InputText
							v-model="model.fzda_nm_arrendatario"
							:label="$t('tenant')"
						/>
						<InputText
							v-model="model.fzda_cd_matricula"
							:label="$t('registration')"
						/>
						<InputText
							v-model="model.fzda_nm_cep"
							:label="$t('zipCode')"
							mask="#####-###"
							@blur="findAddress"
						/>
						<InputText
							v-model="model.fzda_nm_estado"
							:label="$t('state')"
							mask="AA"
						/>

						<InputText
							v-model="model.fzda_nm_bairro"
							:label="$t('district')"
						/>
						<InputText
							v-model="model.fzda_nm_endereco"
							:label="$t('address')"
						/>
					</div>
					<!-- </Accordion> -->

					<div
						v-if="isEdit && mostrarOpcaoDeImportarPoligono"
						style="display: flex; justify-content: space-between; padding: 0.5rem 0"
					>
						<div />
						<p
							class="go__to__plan__text"
							@click="
								actionImportShape = true
								step = 1
							"
						>
							{{ `${$t('goPlan')} ➝` }}
						</p>
					</div>

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('cancel')"
							semantic-class="mini"
							color="trv-secondary"
							outlined
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							:label="isEdit ? $t('save') : $t('import')"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							@click="saveClick()"
						/>
					</div>
				</div>
				<div v-show="actionImportShape">
					<div
						style="
							margin: 1rem 0;
							border-radius: 5px;
							display: flex;
							background-color: var(--color-background);
							align-items: center;
							padding: 1rem;
							flex-direction: row;
							justify-content: space-between;
						"
					>
						<div style="display: flex; flex-direction: row; gap: 1rem">
							<i
								style="vertical-align: sub; font-size: 1.6rem"
								class="fas fa-tree"
							/>
							<p style="height: fit-content; padding: 0.5rem 0; font-size: 1.1rem; margin: 0">
								{{ model.fzda_nm_nome }}
							</p>
						</div>
						<KebabMenu
							v-model="intentionFazenda"
							style="right: 2rem"
							:options="kebabOptionsFazenda"
						/>
					</div>
					<div style="display: flex; justify-content: space-around">
						<p
							class="tab__item"
							:class="{ active__item: tabs === 0 }"
							@click="tabs = 0"
						>
							<strong>
								<i
									v-if="fazendaImported"
									class="fas fa-check"
								/>
								{{ $t('farm') }}</strong
							>
						</p>
						<p
							class="tab__item"
							:class="{ active__item: tabs === 1 }"
							@click="tabs = 1"
						>
							<strong>
								<i
									v-if="talhaoImported"
									class="fas fa-check"
								/>
								{{ $t('section') }}</strong
							>
						</p>
						<p
							class="tab__item"
							:class="{ active__item: tabs === 2 }"
							@click="tabs = 2"
						>
							<strong>
								<i
									v-if="plantioImported"
									class="fas fa-check"
								/>
								{{ $t('plantation') }}</strong
							>
						</p>
					</div>
					<div
						v-if="tabs === 0"
						style="display: flex; flex-direction: column; gap: 0.5rem; padding: 1rem 0"
					>
						<ShapeFileUpload
							ref="ref__shapefileupload"
							:mostrar-importar="false"
							:fzda-id="model.id"
							show-fzda
							:button-enabled="true"
							@showMapTlho="showMapTlho"
							@showMapPtio="showMapPtio"
							@click="saveShapeFazenda"
						/>
						<Accordion
							v-show="fazendaProperties.length"
							:label="`${$t('createCustomVariables')} (${$t('optional')})`"
							:hints="[$t('mapAnyShapeAttribute')]"
						>
							<div style="display: flex; flex-wrap: wrap; gap: 0.3rem; padding: 0.5rem">
								<TagWithButton
									v-for="{ name, value } in fazendaProperties"
									:key="name"
									:identificador-da-tag="{ name, value }"
									:label="name"
									:button-icon="
										customsFazenda.map((m) => m.name).includes(name)
											? 'fas fa-minus'
											: 'fas fa-plus'
									"
									:class-name="
										customsFazenda.map((m) => m.name).includes(name)
											? ['default']
											: ['default', 'outlined']
									"
									@clickEvent="setFazendaCustoms"
								/>
							</div>
						</Accordion>
						<Button
							v-show="fazendaProperties.length"
							:loading="salvandoShapeFazenda"
							:label="$t('saveAndContinue')"
							@click="saveShapeFazenda"
						/>
					</div>

					<div
						v-if="tabs === 1"
						style="padding: 1rem 0"
					>
						<ShapeFileUpload
							ref="ref__shapefileupload"
							:mostrar-importar="false"
							:fzda-id="model.id"
							show-tlho
							:button-enabled="bindsTalhao.codigo != undefined && bindsTalhao.area != undefined"
							@showMapTlho="showMapTlho"
							@showMapPtio="showMapPtio"
							@click="saveShapeTalhao"
						/>

						<div
							v-if="talhaoProperties.length"
							style="display: flex; flex-direction: column; margin-bottom: 40px"
							class="mt-4 gap-4"
						>
							<Dropdown
								key="codigo"
								v-model="bindsTalhao.codigo"
								:options="talhaoProperties"
								:label="$t('sectionCode')"
								icon-label-dropdown="fas fa-font"
								text-after-icon="(String)"
								:help="helpCodigoTalhao"
							/>
							<Dropdown
								key="area"
								v-model="bindsTalhao.area"
								:options="talhaoProperties"
								:label="`${$t('sectionArea')} (ha)`"
								icon-label-dropdown="fas fa-hashtag"
								text-after-icon="(Double)"
								:help="helpAreaTalhao"
							/>

							<Accordion
								:label="$t('optionalFields')"
								:hints="[$t('description'), $t('soilAcronym')]"
							>
								<Dropdown
									key="descricao"
									:options="talhaoProperties"
									:label="`${$t('description')} (${$t('optional')})`"
									@input="setDescricaoTalhao"
								/>
								<Dropdown
									key="solo"
									:options="talhaoProperties"
									:label="`${$t('soilAcronym')} (${$t('optional')})`"
									@input="setSoloTalhao"
								/>
							</Accordion>

							<Accordion
								:label="`${$t('createCustomVariables')} (${$t('optional')})`"
								:hints="[$t('mapAnyShapeAttribute')]"
							>
								<div style="display: flex; flex-wrap: wrap; gap: 0.3rem; padding: 0.5rem">
									<TagWithButton
										v-for="{ name, value } in talhaoProperties"
										:key="name"
										:identificador-da-tag="{ name, value }"
										:label="name"
										:button-icon="
											customsTalhao.map((m) => m.name).includes(name)
												? 'fas fa-minus'
												: 'fas fa-plus'
										"
										:class-name="
											customsTalhao.map((m) => m.name).includes(name)
												? ['default']
												: ['default', 'outlined']
										"
										@clickEvent="setTalhaoCustoms"
									/>
								</div>
							</Accordion>
							<Button
								v-show="talhaoProperties.length"
								:loading="salvandoShapeTalhao"
								:disabled="erroPreencherTlh"
								:label="$t('saveAndContinue')"
								@click="saveShapeTalhao"
							/>
						</div>
					</div>
					<div
						v-if="tabs === 2"
						style="padding: 1rem 0"
					>
						<ShapeFileUpload
							ref="ref__shapefileupload"
							:mostrar-importar="false"
							:fzda-id="model.id"
							show-pltio
							:button-enabled="
								bindsPlantio.codigo != undefined &&
								bindsPlantio.area != undefined &&
								bindsPlantio.talhao != undefined &&
								bindsPlantio.espacamento != undefined &&
								bindsPlantio.data != undefined &&
								bindsPlantio.material != undefined
							"
							@showMapTlho="showMapTlho"
							@showMapPtio="showMapPtio"
							@click="saveShapePlantio"
						/>

						<div
							v-if="plantioProperties.length"
							style="max-height: 30%; display: flex; flex-direction: column; margin-bottom: 20px"
							class="mt-4 gap-4"
						>
							<Dropdown
								v-model="bindsPlantio.talhao"
								:options="plantioProperties"
								:label="`${$t('sectionCode')}`"
								icon-label-dropdown="fas fa-font"
								text-after-icon="(String)"
								:help="helpCodigoTalhao"
							/>

							<Dropdown
								v-model="bindsPlantio.codigo"
								:options="plantioProperties"
								:label="`${$t('plantationCode')}`"
								icon-label-dropdown="fas fa-font"
								text-after-icon="(String)"
								:help="helpCodigoPlantio"
							/>

							<Dropdown
								v-model="bindsPlantio.area"
								:options="plantioProperties"
								:label="`${$t('effectiveArea')} (ha)`"
								icon-label-dropdown="fas fa-hashtag"
								text-after-icon="(Double)"
								:help="helpAreaPlantio"
							/>

							<Dropdown
								v-model="bindsPlantio.data"
								:options="plantioProperties"
								:label="`${$t('plantationDate')}`"
								icon-label-dropdown="fas fa-calendar"
								text-after-icon="(Date)"
								:help="helpDataPlantio"
							/>

							<Dropdown
								v-model="bindsPlantio.material"
								:options="plantioProperties"
								:label="`${$t('geneticMaterial')}`"
								icon-label-dropdown="fas fa-font"
								text-after-icon="(String)"
								:help="helpMaterialPlantio"
							/>

							<Dropdown
								v-model="bindsPlantio.espacamento"
								:options="plantioProperties"
								:label="`${$t('spacing')}`"
								icon-label-dropdown="fas fa-font"
								text-after-icon="(String)"
								:help="helpEspacamentoPlantio"
							/>

							<Accordion
								:label="$t('optionalFields')"
								:hints="[$t('cicle'), $t('rotation'), $t('management')]"
							>
								<Dropdown
									:options="plantioProperties"
									:label="`${$t('stemNumber')} (${$t('optional')})`"
									@input="setFustesPlantio"
								/>
								<Dropdown
									:options="plantioProperties"
									:label="`${$t('stemErrorPercent')} (${$t('optional')})`"
									@input="setErroFustesPlantio"
								/>
								<Dropdown
									:options="plantioProperties"
									:label="`${$t('cicle')} (${$t('optional')})`"
									@input="setCicloPlantio"
								/>
								<Dropdown
									:options="plantioProperties"
									:label="`${$t('rotation')} (${$t('optional')})`"
									@input="setRotacaoPlantio"
								/>

								<Dropdown
									:options="plantioProperties"
									:label="`${$t('management')} (${$t('optional')})`"
									@input="setManejoPlantio"
								/>

								<Dropdown
									:options="plantioProperties"
									:label="`${$t('fertilizing')} (${$t('optional')})`"
									@input="setAdubacaoPlantio"
								/>
							</Accordion>
							<Accordion
								:label="`${$t('createCustomVariables')} (${$t('optional')})`"
								:hints="[$t('mapAnyShapeAttribute')]"
							>
								<div style="display: flex; flex-wrap: wrap; gap: 0.3rem; padding: 0.5rem">
									<TagWithButton
										v-for="{ name, value } in plantioProperties"
										:key="name"
										:identificador-da-tag="{ name, value }"
										:label="name"
										:button-icon="
											customsPlantio.map((m) => m.name).includes(name)
												? 'fas fa-minus'
												: 'fas fa-plus'
										"
										:class-name="
											customsPlantio.map((m) => m.name).includes(name)
												? ['default']
												: ['default', 'outlined']
										"
										@clickEvent="setPlantioCustoms"
									/>
								</div>
							</Accordion>
							<Button
								v-show="plantioProperties.length"
								:loading="salvandoShapePlantio"
								:disabled="erroPreencherPlt"
								:label="$t('saveAndComplete')"
								@click="saveShapePlantio"
							/>
						</div>
					</div>
				</div>
			</template>
		</CrudForm>
		<CrudForm
			:is-visible="erroSolos.length > 0"
			:change-is-visible="() => (erroSolos = [])"
			:title-form="$t('notRegistredSoil')"
		>
			<template #actions>
				<div class="action__buttons__modal__erros">
					<Button
						:label="$t('copyAll')"
						@click="copiaSolo"
					/>
					<Button
						:label="$t('registerManually')"
						@click="goToSolo"
					/>
				</div>
			</template>
			<template #form>
				<div class="container__tags__sigla__solo">
					<p>{{ $t('helpSoilAcronym') }}</p>
					<Tag
						v-for="(solo, index) in [...new Set(erroSolos)]"
						:key="index"
						class="tag__solo__nao__cadastrado"
						class-name="default outlined"
						:label="solo"
					/>
					<Button
						:label="$t('alreadyRegistered')"
						@click="changeIsVisibleModTal"
					/>
				</div>
			</template>
		</CrudForm>

		<CrudForm
			:is-visible="erroTalhoes.length > 0"
			:change-is-visible="() => (erroTalhoes = [])"
			:title-form="$t('notRegistredSection')"
		>
			<template #form>
				<div class="container__tags__sigla__solo">
					<p>{{ $t('helpSection') }}</p>
					<Tag
						v-for="(talhao, index) in [...new Set(erroTalhoes)]"
						:key="index"
						class="tag__solo__nao__cadastrado"
						class-name="default outlined"
						:label="talhao"
					/>

					<Button
						:label="$t('alreadyRegistered')"
						@click="changeIsVisibleMod"
					/>
				</div>
			</template>
		</CrudForm>

		<CrudForm
			:is-visible="erroMateriaisGeneticos.length > 0"
			:change-is-visible="() => (erroMateriaisGeneticos = [])"
			:title-form="$t('notRegistredGeneticMaterial')"
		>
			<template #actions>
				<div class="action__buttons__modal__erros">
					<Button
						:label="$t('copyAll')"
						@click="copiaMaterialGenetico"
					/>
					<Button
						:label="$t('registerManually')"
						@click="goToMaterialGenetico"
					/>
				</div>
			</template>
			<template #form>
				<div class="container__tags__sigla__solo">
					<p>{{ $t('helpGeneticMaterial') }}</p>
					<Tag
						v-for="(material, index) in [...new Set(erroMateriaisGeneticos)]"
						:key="index"
						class="tag__solo__nao__cadastrado"
						class-name="default outlined"
						:label="material"
					/>
					<Button
						:label="$t('alreadyRegistered')"
						@click="changeIsVisibleMod"
					/>
				</div>
			</template>
		</CrudForm>
		<ImportShape
			v-if="actionImportShape"
			:toggle-plantio="togglePlantio"
			:close="closeImportShape"
			:fzda-id="model.id"
		/>

		<ModalConfirm
			v-if="showModalConfirmacao"
			:disabled_item="model.fzda_nm_nome"
			:item_type="$t('deactivateFarm')"
			@desativar_registro="desativar_fazenda()"
			@cancelar_desativacao="cancelar_desativar_fazenda()"
		/>

		<ModalError
			v-if="showModalError"
			:ordens_servico="ordensDeServico"
			:disabled_item="model.fzda_nm_nome"
			:item_type="$t('farm')"
			@fechar_model_error="fecha_model_error()"
		/>
	</div>
</template>

<script>
import ShapeFileUpload from '@/views/Cadastros/Florestal/Fazenda/ImportShape/ShapeFileUpload/ShapeFileUpload.vue'
import Accordion from '../../../../components/Accordion/Accordion'
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import Dropdown from '../../../../components/Dropdown/Dropdown.vue'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox.vue'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import Pagination from '../../../../components/Pagination/Pagination'
import Tag from '../../../../components/Tag/Tag.vue'
import TagWithButton from '../../../../components/TagWithButton/TagWithButton.vue'
import ImportShape from '../Fazenda/ImportShape/ImportShape'
import Switcher from '../../../../components/Switcher/Switcher'
import { v4 as uuidv4 } from 'uuid'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu.vue'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createFazenda,
	deleteFazendaByIdList,
	getAllFazendas,
	getAllShapesByFazendaId,
	importShapeFazenda,
	importShapePlantio,
	importShapeTalhao,
	updateFazenda,
} from '../../../../services/requests/FazendaRequests'

import { getAddress } from '../../../../services/requests/ApiRequests'

import * as turf from '@turf/turf'
import download from 'downloadjs'
import { exportarCsv } from '../../../../utils/csvHellpers'

import ModalConfirm from '../../../../components/ModalConfirm/ModalConfirm.vue'
import ModalError from '../../../../components/ModalError/ModalError.vue'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'Fazenda',
	components: {
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		DropdownCheckbox,
		ImportShape,
		InputSearch,
		InputText,
		Pagination,
		Accordion,
		BreadCrumb,
		ShapeFileUpload,
		Dropdown,
		Tag,
		TagWithButton,
		Switcher,
		ModalConfirm,
		ModalError,
		ExclusionAlert,
	},
	computed: {
		...mapGetters('moduleImportShape', [
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'isGeoJsonTalhaoEmpty',
			'isGeoJsonPlantioEmpty',
			'isGeoJsonFazendaEmpty',
		]),
		kebabOptionsFazenda() {
			return [
				{
					value: 'toggleInfoPlantio',
					label: `${
						this.togglePlantio ? this.$t('hide') : this.$t('show')
					} ${this.$t('plantingInfo')}`,
				},
				{
					value: 'downloadFazenda',
					label: this.$t('downloadFazenda'),
				},
				{
					value: 'downloadTalhao',
					label: this.$t('downloadTalhao'),
				},
				{
					value: 'downloadPlantio',
					label: this.$t('downloadPlantio'),
				},
			]
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},

		fazendaProperties: {
			get: function () {
				return this.isGeoJsonFazendaEmpty
					? []
					: Object.entries(this.getGeoJsonFzda.properties).map(([chave, valor]) => {
							return {
								label: `${chave}: ${valor}`,
								value: chave,
								key: chave,
								isActive: false,
								name: chave,
							}
						})
			},

			set: function (value) {
				this.customsFazenda = value
			},
		},

		talhaoProperties: {
			get: function () {
				return this.isGeoJsonTalhaoEmpty
					? []
					: Object.entries(this.getGeoJsonTlho.properties).map(([chave, valor]) => {
							return {
								label: `${chave}: ${valor}`,
								value: chave,
								key: chave,
								isActive: false,
								name: chave,
							}
						})
			},

			set: function (value) {
				this.customsTalhao = value
			},
		},

		plantioProperties: {
			get: function () {
				return this.isGeoJsonPlantioEmpty
					? []
					: Object.entries(this.getGeoJsonPtio.properties).map(([chave, valor]) => {
							return {
								label: `${chave}: ${valor}`,
								value: chave,
								key: chave,
								name: chave,
							}
						})
			},

			set: function (value) {
				this.customsPlantio = value
			},
		},

		erroPreencherTlh() {
			return (
				!this.bindsTalhao.codigo || !this.bindsTalhao.area || this.erroTlhCodigo || this.erroTlhArea
			)
		},
		erroPreencherPlt() {
			return (
				!this.bindsPlantio.codigo ||
				!this.bindsPlantio.area ||
				!this.bindsPlantio.talhao ||
				!this.bindsPlantio.espacamento ||
				!this.bindsPlantio.data ||
				!this.bindsPlantio.material ||
				this.erroPltCodigo ||
				this.erroPltArea ||
				this.erroPltTalhao ||
				this.erroPltEspacamento ||
				this.erroPltData ||
				this.erroPltMaterial
			)
		},

		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.fzda_nm_nome && this.model.fzda_nm_municipio && this.model.fzda_nm_pais
		},
	},
	data() {
		return {
			step: 0,
			criandoFazenda: false,

			erroTlhCodigo: false,
			erroTlhArea: false,
			erroPltCodigo: false,
			erroPltArea: false,
			erroPltTalhao: false,
			erroPltEspacamento: false,
			erroPltData: false,
			erroPltMaterial: false,
			showModalError: false,
			desativou_fazenda: false,
			salvandoShapeFazenda: false,
			salvandoShapeTalhao: false,
			salvandoShapePlantio: false,
			fazendaImported: false,
			talhaoImported: false,
			plantioImported: false,
			togglePlantio: this.isEdit ? true : false,
			intention: {},
			intentionFazenda: {},
			mostrarOpcaoDeImportarPoligono: false,
			showExclusionAlert: false,
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'fzda_ds_descricao',
				titleCardPropertie: 'fzda_cd_codigo',
			},
			tableHeaders: [
				{ key: 'fzda_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'fzda_nm_nome', value: this.$t('name'), isActive: true },
				{
					key: 'fzda_ds_descricao',
					value: this.$t('description'),
					isActive: false,
				},
				{ key: 'fzda_md_area', value: this.$t('area'), isActive: true },
				{ key: 'fzda_nm_pais', value: this.$t('country'), isActive: false },
				{ key: 'fzda_nm_estado', value: this.$t('state'), isActive: true },
				{
					key: 'fzda_nm_municipio',
					value: this.$t('city'),
					isActive: true,
				},
				{
					key: 'fzda_nm_bairro',
					value: this.$t('district'),
					isActive: false,
				},
				{ key: 'fzda_nm_cep', value: this.$t('zipCode'), isActive: false },
				{
					key: 'fzda_nm_endereco',
					value: this.$t('address'),
					isActive: false,
				},
				{
					key: 'fzda_nm_proprietario',
					value: this.$t('owner'),
					isActive: false,
				},
				{
					key: 'fzda_nm_arrendatario',
					value: this.$t('tenant'),
					isActive: false,
				},
				{
					key: 'fzda_cd_matricula',
					value: this.$t('registration'),
					isActive: false,
				},
				{
					key: 'fzda_nm_referencia',
					value: this.$t('reference'),
					isActive: false,
				},

				{
					key: 'ativo',
					value: this.$t('registration_status'),
					isActive: false,
				},
			],
			headersSelecionados: [
				'fzda_cd_codigo',
				'fzda_nm_nome',
				'fzda_md_area',
				'fzda_nm_estado',
				'fzda_nm_municipio',
				'ativo',
			],
			isResumo: false,

			/**
			 * propriedade que passa mensagem para o dropdown de area de talhão
			 */
			helpAreaTalhao: {},
			/**
			 * propriedade que passa mensagem para o dropdown de area de plantio
			 */
			helpAreaPlantio: {},
			/**
			 * propriedade que passa mensagem para o dropdown de data de plantio
			 */
			helpDataPlantio: {},

			/**
			 * propriedade que passa mensagem para o dropdown de codigo de plantio
			 */
			helpCodigoPlantio: {},

			/**
			 * propriedade que passa mensagem para o dropdown de codigo de talhao
			 */
			helpCodigoTalhao: {},

			/**
			 * Objeto que recebe chave mapeada nos dropdowns de mapeamento de propriedades
			 */
			helpEspacamentoPlantio: {},
			/**
			 *        * Objeto que recebe chave mapeada nos dropdowns de mapeamento de propriedades
			 *        */
			helpMaterialPlantio: {},
			/**
			 *        * Objeto que recebe chave mapeada nos dropdowns de mapeamento de propriedades
			 */
			bindsTalhao: {
				codigo: undefined,
				solo: undefined,
				area: undefined,
				descricao: undefined,
			},

			/**
			 * lista que contém solos não cadastrados no sistema. Para finalizar o cadastro de talhão é necessario que verifique o mapeamento ou cadastre os solos não cadastados
			 */
			erroSolos: [],
			erroMateriaisGeneticos: [],
			erroTalhoes: [],
			bindsPlantio: {
				area: undefined,
				data: undefined,
				codigo: undefined,
				material: undefined,
				espacamento: undefined,
				talhao: undefined,
				fustes: undefined,
				erroFustes: undefined,
				ciclo: undefined,
				rotacao: undefined,
				manejo: undefined,
				adubacao: undefined,
			},

			customsFazenda: [],
			customsTalhao: [],
			customsPlantio: [],
			tabs: 0,

			items2: [this.$t('mapProperties')],
			items3: [this.$t('mapProperties')],
			actionImportShape: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				fzda_cd_codigo: '',
				fzda_nm_nome: '',
				fzda_ds_descricao: '',
				fzda_nm_proprietario: '',
				fzda_nm_arrendatario: '',
				fzda_cd_matricula: '',
				fzda_md_area: '',
				fzda_nm_cep: '',
				fzda_nm_estado: '',
				fzda_nm_municipio: '',
				fzda_nm_bairro: '',
				fzda_nm_endereco: '',
				fzda_nm_pais: '',
				ativo: true,
			},
			/**
			 * Configuração da tabela
			 */
			valueSelected: {
				menu: [
					{
						key: 'editar',
						value: this.$t('edit'),
						isActive: false,
					},
					{ key: 'resumo', value: this.$t('summary'), isActive: false },
					{
						key: 'dispersao',
						value: this.$t('visualizeDispersion'),
						isActive: false,
					},
				],
			},
			/**
			 * Dados para conseguir fazer o auto-complete do mapeamento
			 */
			mapeamentoTalhao: [
				{
					nome: 'talhao',
					regex: new RegExp('t.*lh', 'gi'),
				},
				{
					nome: 'area_talhao',
					regex: new RegExp('a.*r.*t.*l', 'gi'),
				},
			],
			mapeamentoPlantio: [
				{
					nome: 'talhao',
					regex: new RegExp('c.*t.*lh', 'gi'),
				},
				{
					nome: 'plantio',
					regex: new RegExp('c.*p.*t.*o.*', 'gi'),
				},
				{
					nome: 'area',
					regex: new RegExp('a.*r.*e', 'gi'),
				},
				{
					nome: 'data_do_plantio',
					regex: new RegExp('d.*t.*p.*t', 'gi'),
				},
				{
					nome: 'material_genetico',
					regex: new RegExp('m.*t.*g', 'gi'),
				},
				{
					nome: 'espacamento',
					regex: new RegExp('e.*p.*t', 'gi'),
				},
			],
		}
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		isGeoJsonFazendaEmpty(value) {
			if (!value && this.getGeoJsonFzda.properties.customs) {
				this.customsFazenda = this.getGeoJsonFzda.properties.customs.map(({ Name, Value }) => {
					return { name: Name, value: Value }
				})
			}
		},
		isGeoJsonTalhaoEmpty(value) {
			if (!value && this.getGeoJsonTlho.features[0].properties.customs) {
				this.customsTalhao = this.getGeoJsonTlho.features[0].properties.customs.map(
					({ Name, Value }) => {
						return { name: Name, value: Value }
					},
				)
			}
		},
		isGeoJsonPlantioEmpty(value) {
			if (!value && this.getGeoJsonPtio.features[0].properties.customs) {
				this.customsPlantio = this.getGeoJsonPtio.features[0].properties.customs.map(
					({ Name, Value }) => {
						return { name: Name, value: Value }
					},
				)
			}
		},

		isModalConfirmActive() {
			if (this.isModalConfirmActive) {
				return true
			} else {
				return false
			}
		},

		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
		intentionFazenda(value) {
			const intentionsMapped = {
				downloadFazenda: this.actionDownloadFazenda,
				downloadTalhao: this.actionDownloadTalhao,
				downloadPlantio: this.actionDownloadPlantio,
				toggleInfoPlantio: () => (this.togglePlantio = !this.togglePlantio),
			}

			if (value.intent) intentionsMapped[value.intent]()
		},
		'bindsTalhao.codigo': function (newVal) {
			let codigos = this.getGeoJsonTlho.features.map((m) => m.properties[newVal])
			if (
				codigos.filter((e, i, a) => a.indexOf(e) !== i).length ||
				this.getGeoJsonTlho.features.some(
					(feature) => !isNaN(feature.properties[newVal]) && feature.properties[newVal] % 1 !== 0,
				)
			) {
				this.helpCodigoTalhao = {
					message: this.$t('helpSectionCode'),
					type: 'error',
				}
				this.erroTlhCodigo = true
			} else {
				this.helpCodigoTalhao = {}
				this.erroTlhCodigo = false
			}
		},
		'bindsPlantio.codigo': function (newVal) {
			let codigos = this.getGeoJsonPtio.features.map((m) => m.properties[newVal])
			if (
				codigos.filter((e, i, a) => a.indexOf(e) !== i).length ||
				this.getGeoJsonTlho.features.some(
					(feature) => !isNaN(feature.properties[newVal]) && feature.properties[newVal] % 1 !== 0,
				)
			) {
				this.helpCodigoPlantio = {
					message: this.$t('helpPlantationCode'),
					type: 'error',
				}
				this.erroPltCodigo = true
			} else {
				this.helpCodigoPlantio = {}
				this.erroPltCodigo = false
			}
		},
		'bindsPlantio.talhao': function (newVal) {
			let codigos = this.getGeoJsonPtio.features.map((m) => m.properties[newVal])

			if (
				codigos.filter((e, i, a) => a.indexOf(e) !== i).length ||
				this.getGeoJsonTlho.features.some(
					(feature) => !isNaN(feature.properties[newVal]) && feature.properties[newVal] % 1 !== 0,
				)
			) {
				this.helpCodigoTalhao = {
					message: this.$t('helpSectionCode'),
					type: 'error',
				}
				this.erroPltTalhao = true
			} else {
				this.helpCodigoTalhao = {}
				this.erroPltTalhao = false
			}
		},
		'bindsTalhao.area': function (newVal) {
			if (
				this.getGeoJsonTlho.features.some(
					(feature) => isNaN(feature.properties[newVal]) || feature.properties[newVal] == '',
				)
			) {
				this.helpAreaTalhao = {
					message: this.$t('helpSectionArea'),
					type: 'error',
				}
				this.erroTlhArea = true
			} else {
				this.helpAreaTalhao = {}
				this.erroTlhArea = false
			}
		},
		'bindsPlantio.area': function (newVal) {
			if (
				this.getGeoJsonPtio.features.some(
					(feature) => isNaN(feature.properties[newVal]) || feature.properties[newVal] == '',
				)
			) {
				this.helpAreaPlantio = {
					message: this.$t('helpPlantationArea'),
					type: 'error',
				}
				this.erroPltArea = true
			} else {
				this.helpAreaPlantio = {}
				this.erroPltArea = false
			}
		},
		'bindsPlantio.data': function (newVal) {
			if (
				this.getGeoJsonPtio.features.some((feature) =>
					isNaN(new Date(feature.properties[newVal]).getTime()),
				)
			) {
				this.helpDataPlantio = {
					message: this.$t('helpPlantationDate'),
					type: 'error',
				}
				this.erroPltData = true
			} else {
				this.helpDataPlantio = {}
				this.erroPltData = false
			}
		},
		'bindsPlantio.material': function (newVal) {
			if (
				this.getGeoJsonPtio.features.some(
					(feature) =>
						feature.properties[newVal] === '' || typeof feature.properties[newVal] !== 'string',
				)
			) {
				this.helpMaterialPlantio = {
					message: this.$t('helpGeneticMaterial'),
					type: 'error',
				}
				this.erroPltMaterial = true
			} else {
				this.helpMaterialPlantio = {}
				this.erroPltMaterial = false
			}
		},
		'bindsPlantio.espacamento': function (newVal) {
			if (
				this.getGeoJsonPtio.features.some(
					(feature) =>
						feature.properties[newVal] === '' || typeof feature.properties[newVal] !== 'string',
				)
			) {
				this.helpEspacamentoPlantio = {
					message: this.$t('helpSpacing'),
					type: 'error',
				}
				this.erroPltEspacamento = true
			} else {
				this.helpEspacamentoPlantio = {}
				this.erroPltEspacamento = false
			}
		},

		// Watchers para conseguir fazer o auto complete dos dropdowns
		'$store.state.moduleImportShape.geoJsonTlho': {
			immediate: true,
			deep: true,
			async handler(value) {
				if (this.actionImportShape && value.properties) {
					const propriedades = Object.keys(value.properties)

					let dadosMapeados = 0
					propriedades.forEach((propriedade) => {
						var mapeamentoEncontrado = this.mapeamentoTalhao.filter((mapeamento) =>
							mapeamento.regex.test(propriedade),
						)
						if (mapeamentoEncontrado.length > 0) {
							switch (mapeamentoEncontrado[0].nome) {
								case 'talhao':
									this.setCodigoTalhao(propriedade)
									break
								case 'area_talhao':
									this.setAreaTalhao(propriedade)
									break
							}
							dadosMapeados++
						}

						// Se a quantidade de dados mapeados for igual a quantidade de dados que podem ser mapeados sai da funcao
						if (dadosMapeados === this.mapeamentoTalhao.length) return
					})
				}
			},
		},
		'$store.state.moduleImportShape.geoJsonPtio': {
			immediate: true,
			deep: true,
			async handler(value) {
				if (this.actionImportShape && value.properties) {
					const propriedades = Object.keys(value.properties)

					let dadosMapeados = 0
					propriedades.forEach((propriedade) => {
						var mapeamentoEncontrado = this.mapeamentoPlantio.filter((mapeamento) =>
							mapeamento.regex.test(propriedade),
						)
						if (mapeamentoEncontrado.length > 0) {
							switch (mapeamentoEncontrado[0].nome) {
								case 'talhao':
									this.setCodigoTalhaoPlantio(propriedade)
									break
								case 'plantio':
									this.setCodigoPlantio(propriedade)
									break
								case 'area':
									this.setAreaPlantio(propriedade)
									break
								case 'data_do_plantio':
									this.setDataPlantio(propriedade)
									break
								case 'material_genetico':
									this.setMaterialPlantio(propriedade)
									break
								case 'espacamento':
									this.setEspacamentoPlantio(propriedade)
									break
							}

							dadosMapeados++
						}

						// Se a quantidade de dados mapeados for igual a quantidade de dados que podem ser mapeados sai da funcao
						if (dadosMapeados === this.mapeamentoPlantio.length) return
					})
				}
			},
		},
	},
	methods: {
		...mapActions('moduleImportShape', ['setAllShapes']),
		actionDownloadFazenda() {
			download(
				JSON.stringify(this.getGeoJsonFzda),
				`GeoJSON ${this.$t('farm')} ${this.model.fzda_nm_nome} ${new Date()
					.toLocaleDateString()
					.replaceAll('/', '-')}`,
				'application/json',
			)
		},

		desativar_fazenda() {
			this.update()
		},

		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		fecha_model_error() {
			this.showModalError = false
		},

		cancelar_desativar_fazenda() {
			this.desativou_fazenda = false
			this.showModalConfirmacao = false
			window.location.reload()
		},

		atualiza_status_fazenda() {
			if (this.model.ativo == false) {
				this.desativou_fazenda = true
			} else {
				this.desativou_fazenda = false
			}
		},

		actionDownloadTalhao() {
			download(
				JSON.stringify(this.getGeoJsonTlho.geojson),
				`GeoJSON ${this.$t('section')} ${this.model.fzda_nm_nome} ${new Date()
					.toLocaleDateString()
					.replaceAll('/', '-')}`,
				'application/json',
			)
		},

		actionDownloadPlantio() {
			download(
				JSON.stringify(this.getGeoJsonPtio.geojson),
				`GeoJSON ${this.$t('plantation')} ${
					this.model.fzda_nm_nome
				} ${new Date().toLocaleDateString().replaceAll('/', '-')}`,
				'application/json',
			)
		},

		downloadCSVFazenda() {
			let cabecalhoDoCsvFzda = [
				'Código',
				'Nome',
				'Descrição',
				'Área',
				'País',
				'UF',
				'Cidade',
				'Bairro',
				'CEP',
				'Endereço',
				'Proprietário',
				'Arrendatário',
				'Matrícula',
				'Referência',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.fzda_cd_codigo,
				item.fzda_nm_nome,
				item.fzda_ds_descricao,
				item.fzda_md_area,
				item.fzda_nm_pais,
				item.fzda_nm_estado,
				item.fzda_nm_municipio,
				item.fzda_nm_bairro,
				item.fzda_nm_cep,
				item.fzda_nm_endereco,
				item.fzda_nm_proprietario,
				item.fzda_nm_arrendatario,
				item.fzda_cd_matricula,
				item.fzda_nm_referencia,
			])

			exportarCsv('export_fzda', cabecalhoDoCsvFzda, linhas)
		},

		setFazendaCustoms({ name, value }) {
			const custom = this.customsFazenda.find((c) => {
				return c.name === name
			})
			if (custom) {
				this.customsFazenda.splice(this.customsFazenda.indexOf(custom), 1)
			} else {
				this.customsFazenda.push({ name, value })
			}
		},
		setTalhaoCustoms({ name, value }) {
			const custom = this.customsTalhao.find((c) => {
				return c.name === name
			})
			if (custom) {
				this.customsTalhao.splice(this.customsTalhao.indexOf(custom), 1)
			} else {
				this.customsTalhao.push({ name, value })
			}
		},
		setPlantioCustoms({ name, value }) {
			const custom = this.customsPlantio.find((c) => {
				return c.name === name
			})
			if (custom) {
				this.customsPlantio.splice(this.customsPlantio.indexOf(custom), 1)
			} else {
				this.customsPlantio.push({ name, value })
			}
		},
		copiaSolo() {
			navigator.clipboard.writeText(this.erroSolos.toString())
		},
		copiaMaterialGenetico() {
			navigator.clipboard.writeText([...new Set(this.erroMateriaisGeneticos)].toString())
		},
		goToSolo() {
			let route = this.$router.resolve({ name: 'solo' })
			window.open(route.href, '_blank')
		},
		goToMaterialGenetico() {
			let route = this.$router.resolve({ name: 'materialGenetico' })
			window.open(route.href, '_blank')
		},
		preparaTalhoes() {
			return this.getGeoJsonTlho.features.map((f) => {
				return {
					codigo: f.properties[this.bindsTalhao.codigo],
					area: f.properties[this.bindsTalhao.area],
					descricao: f.properties[this.bindsTalhao.descricao],
					siglaSolo: f.properties[this.bindsTalhao.solo],
					geojson: JSON.stringify(f.geometry),
					customVariables: this.customsTalhao.map(({ name }) => {
						return {
							name: name,
							value: f.properties[name],
						}
					}),
				}
			})
		},

		preparaPlantios() {
			return this.getGeoJsonPtio.features.map((f) => {
				return {
					id: uuidv4(),
					codigo: f.properties[this.bindsPlantio.codigo],
					dataDoPlantio: f.properties[this.bindsPlantio.data],
					area: f.properties[this.bindsPlantio.area],
					espacamento: f.properties[this.bindsPlantio.espacamento],
					numeroDeFustes: Math.round(f.properties[this.bindsPlantio.fustes]),
					// numeroDeArvores: f.properties[this.bindsPlantio.arvores],
					ciclo: f.properties[this.bindsPlantio.ciclo],
					tipoDeAdubacao: f.properties[this.bindsPlantio.adubacao],
					manejo: f.properties[this.bindsPlantio.manejo],
					rotacao: f.properties[this.bindsPlantio.rotacao],
					codigoTalhao: f.properties[this.bindsPlantio.talhao],
					materialGenetico: f.properties[this.bindsPlantio.material],
					erro: f.properties[this.bindsPlantio.erroFustes],
					geojson: JSON.stringify(f.geometry),
					customVariables: this.customsPlantio.map(({ name }) => {
						return {
							name: name,
							value: f.properties[name],
						}
					}),
				}
			})
		},

		setCodigoPlantio(value) {
			this.bindsPlantio.codigo = value
		},
		setAreaPlantio(value) {
			this.bindsPlantio.area = value
		},
		setDataPlantio(value) {
			this.bindsPlantio.data = value
		},
		setMaterialPlantio(value) {
			this.bindsPlantio.material = value
		},
		setEspacamentoPlantio(value) {
			this.bindsPlantio.espacamento = value
		},
		setCodigoTalhaoPlantio(value) {
			this.bindsPlantio.talhao = value
		},
		setFustesPlantio(value) {
			this.bindsPlantio.fustes = value
		},
		setErroFustesPlantio(value) {
			this.bindsPlantio.erroFustes = value
		},
		setCicloPlantio(value) {
			this.bindsPlantio.ciclo = value
		},
		setRotacaoPlantio(value) {
			this.bindsPlantio.rotacao = value
		},
		setManejoPlantio(value) {
			this.bindsPlantio.manejo = value
		},
		setAdubacaoPlantio(value) {
			this.bindsPlantio.adubacao = value
		},
		setCodigoTalhao(value) {
			this.bindsTalhao.codigo = value
		},
		setAreaTalhao(value) {
			this.bindsTalhao.area = value
		},
		setDescricaoTalhao(value) {
			this.bindsTalhao.descricao = value
		},
		setSoloTalhao(value) {
			this.bindsTalhao.solo = value
		},
		...mapMutations('moduleImportShape', [
			'resetState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonPtio',
			'setFzdaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
		]),
		async saveShapeFazenda() {
			this.salvandoShapeFazenda = true
			try {
				await importShapeFazenda({
					id: this.model.id,
					geojson: JSON.stringify(this.getGeoJsonFzda.geojson.features[0].geometry),
					area: turf.area(this.getGeoJsonFzda.geojson.features[0].geometry) / 10000,
					customVariables: this.customsFazenda,
				})

				this.tabs = 1
				this.setFzdaHasFileInDB(true)
				this.fazendaImported = true
				this.salvandoShapeFazenda = false
			} catch (err) {
				console.log(err)
				this.salvandoShapeFazenda = false
			}
		},
		async saveShapeTalhao() {
			this.salvandoShapeTalhao = true
			try {
				const { data } = await importShapeTalhao({
					fazendaId: this.model.id,
					talhoes: this.preparaTalhoes(),
				})

				/**
				 * * verifica se ao importar, sigla de solo está cadastrada no sistema
				 * ? rola de melhorar este retorno? temos que fazer muitas operações para poder expor a mensagem para o usuário.
				 */
				if (data.result.length) {
					this.salvandoShapeTalhao = false
					this.erroSolos = data.result.map((message) => message.recurso)
				} else {
					this.tabs = 2
					this.salvandoShapeTalhao = false
					this.talhaoImported = true
					this.setTlhoHasFileInDB(true)
				}
			} catch (err) {
				console.log(err)
				this.salvandoShapeTalhao = false
			}
		},
		async saveShapePlantio() {
			this.salvandoShapePlantio = true
			try {
				const { data } = await importShapePlantio({
					fazendaId: this.model.id,
					plantios: this.preparaPlantios(),
				})

				/**
				 * * verifica se ao importar, sigla de solo está cadastrada no sistema
				 * ? rola de melhorar este retorno? temos que fazer muitas operações para poder expor a mensagem para o usuário.
				 */
				if (data.result.length) {
					this.salvandoShapePlantio = false

					if (data.result[0].message.includes('Material Genetico'))
						this.erroMateriaisGeneticos = data.result.map((message) => message.recurso)
					else if (data.result[0].message.includes('Talhão'))
						this.erroTalhoes = data.result.map((message) => message.recurso)
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageText: this.$t('importacaoRealizada'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
					this.setPtioHasFileInDB(true)
					this.plantioImported = true
					this.salvandoShapePlantio = false
					this.actionImportShape = !this.actionImportShape
					this.showForm = false
					this.step = 0
				}
			} catch (err) {
				console.log(err)
				this.salvandoShapePlantio = false
			}
		},
		voltar() {
			console.log(this.getGeoJsonFzda)
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createFazendaToPost() {
			return {
				fzda_nm_nome: this.model.fzda_nm_nome,
				fzda_ds_descricao: this.model.fzda_ds_descricao,
				fzda_nm_proprietario: this.model.fzda_nm_proprietario,
				fzda_nm_arrendatario: this.model.fzda_nm_arrendatario,
				fzda_cd_matricula: this.model.fzda_cd_matricula,
				fzda_nm_cep: this.model.fzda_nm_cep.replace('-', ''),
				fzda_nm_estado: this.model.fzda_nm_estado,
				fzda_nm_municipio: this.model.fzda_nm_municipio,
				fzda_nm_bairro: this.model.fzda_nm_bairro,
				fzda_nm_endereco: this.model.fzda_nm_endereco,
				fzda_nm_pais: this.model.fzda_nm_pais,
				ativo: this.model.ativo,
			}
		},

		/**
		 * Exibe os campos para mapeamento de dados de plantio
		 */
		showMapPtio() {
			this.isImportShp = false
			this.isMappedTlho = false
			this.isMappedPtio = true
		},

		/**
		 * Exibe os campos para mapeamento de dados de talhao
		 */
		showMapTlho() {
			this.isImportShp = false
			this.isMappedPtio = false
			this.isMappedTlho = true
		},

		/**
		 * Cria nova Fazenda no banco de dados
		 */
		create() {
			const body = this.createFazendaToPost()

			createFazenda(body).then((response) => {
				const fazenda = response.data
				const isError = response.status

				this.disableSaveButton = false
				console.log('fazenda: ', fazenda)

				if (isError == 200) {
					this.cleanModel()
					this.formataFazendaParaTabela(fazenda)
					this.modelList.unshift(fazenda)
					this.model = JSON.parse(JSON.stringify(fazenda))

					// this.showForm = false;

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})

					this.actionImportShape = !this.actionImportShape
					this.step = 1
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Procura o endereco apos digitar o cep
		 */
		findAddress() {
			if (this.model.fzda_nm_cep) {
				getAddress(this.model.fzda_nm_cep)
					.then((response) => {
						const { data: localizacao } = response
						this.model.fzda_nm_estado = localizacao.uf
						this.model.fzda_nm_municipio = localizacao.localidade
						this.model.fzda_nm_bairro = localizacao.bairro
						this.model.fzda_nm_endereco = localizacao.logradouro
					})
					.catch(() => {
						this.mutationShowMessage({
							messageTitle: this.$t('cepDigitadoNaoExiste'),
							messageText: this.$t('cepNaoExiste'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
						this.model.fzda_nm_estado = ''
						this.model.fzda_nm_municipio = ''
						this.model.fzda_nm_bairro = ''
						this.model.fzda_nm_endereco = ''
					})
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataFazendaParaTabela(fazenda) {
			fazenda.isCheckedToDelete = false
			fazenda.fzda_md_area = fazenda.fzda_md_area?.toFixed(2)
			if (fazenda.ativo == true) {
				fazenda.ativo = this.$t('active')
			} else {
				fazenda.ativo = this.$t('inactive')
			}
		},

		/**
		 * Atualiza fazenda no banco de dados
		 */
		update() {
			this.model.fzda_nm_cep = this.model.fzda_nm_cep.replace('-', '')
			this.showForm = false

			updateFazenda(this.model).then((response) => {
				const fazenda = response.data.resultado
				const isError = response.status
				const ordensDeServico = response.data.ordensServicosAbertas
				this.disableSaveButton = false
				this.showModalConfirmacao = false
				if (isError == 200 && ordensDeServico.length == 0) {
					this.formataFazendaParaTabela(fazenda)

					const indexFazenda = this.modelList.map((fazenda) => fazenda.id).indexOf(fazenda.id)

					this.$set(this.modelList, indexFazenda, fazenda)

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else if (isError == 200 && ordensDeServico.length > 0) {
					this.showModalError = true
					this.ordensDeServico = response.data.ordensServicosAbertas
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(fazenda) =>
						this.modelsIdWithCheckedToDelete.includes(fazenda.id) &&
						fazenda.possuiDependenciaDeRegistro,
				)

				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')
					if (confirmResult) {
						deleteFazendaByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var fazendasOrganizadas = existeRegistroComDependencia
						.map((fazenda) => `• Fazenda: ${fazenda.fzda_cd_codigo} - ${fazenda.fzda_nm_nome}`)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaDeTalhao')}:</b> <br/><br/> ${fazendasOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				if (this.desativou_fazenda) {
					this.showModalConfirmacao = true
					this.showForm = false
					return
				}
				this.showForm = false
				if (this.model.ativo == 'Inativo') {
					this.model.ativo = false
				} else {
					this.model.ativo = true
				}
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */

		async showEditModelForm(fazenda) {
			this.model = Object.assign({}, fazenda)
			this.titleForm = `${this.$t('edit')} ${this.$t('farm')}`
			this.isEdit = true
			this.togglePlantio = true
			this.criandoFazenda = false
			this.mostrarOpcaoDeImportarPoligono = false
			this.changeFormAndCloseAllActions()
			if (this.model.ativo == 'Inativo') {
				this.model.ativo = false
			}

			try {
				const response = await getAllShapesByFazendaId(this.model.id)

				const fazenda = JSON.parse(response.data.result.fazenda)
				const talhoes = JSON.parse(response.data.result.talhoes)
				const plantios = JSON.parse(response.data.result.plantios)

				this.setAllShapes({
					fazenda,
					talhoes,
					plantios,
				})

				if (Object.values(fazenda).length) {
					this.fazendaImported = true
				}

				if (Object.values(talhoes).length) {
					this.talhaoImported = true
				}

				if (Object.values(plantios).length) {
					this.plantioImported = true
				}

				this.mostrarOpcaoDeImportarPoligono = true

				this.tabs = 0
			} catch {
				throw new Error('Não foi possível buscar shapes da fazenda')
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			// this.model = Object.assign({}, model);
			this.model.ativo = true
			this.criandoFazenda = true

			this.titleForm = this.$t('createFarm')
			this.isEdit = false
			this.changeFormAndCloseAllActions()

			this.tabs = 0
		},
		showResumoModelForm(model) {
			this.model = Object.assign({}, model)
			console.log('showresumo')

			this.isResumo = !this.isResumo

			this.titleForm = this.$t('summary')
		},
		changeFormAndCloseAllActionsResumo() {
			this.isResumo = !this.isResumo
		},
		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.closeImportShape()
			this.resetState()
		},
		actionButtonImportShape() {
			this.actionImportShape = !this.actionImportShape
			this.showForm = false
			this.titleForm = ''
		},
		/**
		 * Fecha a importacao de shape
		 */
		closeImportShape() {
			this.actionImportShape = false
		},

		changeIsVisibleMod() {
			this.erroMateriaisGeneticos.length = 0
			this.erroTalhoes.length = 0
			this.saveShapePlantio()
		},

		changeIsVisibleModTal() {
			this.erroSolos.length = 0
			this.saveShapeTalhao()
		},
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['fzda_cd_codigo']
		getAllFazendas().then((response) => {
			const fazendas = response.data

			fazendas.forEach((fazenda) => {
				fazenda.isCheckedToDelete = false
				fazenda.fzda_md_area = fazenda.fzda_md_area?.toFixed(2)
				if (fazenda.ativo == true) {
					fazenda.ativo = this.$t('active')
				} else {
					fazenda.ativo = this.$t('inactive')
				}
			})
			this.modelList = fazendas
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		this.$root.$on('languagesChanged', () => {
			console.log('passou aqui')
		})

		console.log('!this.isGeoJsonFazendaEmpty', !this.isGeoJsonFazendaEmpty)
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>

<style scoped>
.container__tags__sigla__solo {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	margin-top: 1rem;
	gap: 0.5rem;
	justify-content: center;
}

.action__buttons__modal__erros {
	display: flex;
	margin-top: 0.5rem;
}

.v-card.v-card--flat.v-sheet.theme--light,
.v-card__text {
	height: 100%;
}

.go__to__plan__text {
	margin: 0;
	text-align: end;
	font-size: 0.8rem;
	cursor: pointer;
}

.go__to__plan__text:hover {
	color: var(--color-green);
}

.active__item::after {
	content: '';
	background: var(--color-green);
	display: block;
	height: 2px;
}

.tab__item {
	margin: 0;
	width: 33.33%;
	text-align: center;
	cursor: pointer;
}

.tab__item:hover {
	background: var(--color-success-message);
}

.tab__item strong {
	line-height: 3;
	gap: 0.5rem;
	display: flex;
	align-items: center;
	flex-direction: row;
	justify-content: center;
}
</style>
